;(function CartDataService() {
    function CartDataService() {
        /**
         * local OrderDataService
         * @private
         */
        var _this = this

        /**
         * config
         */
        this.config = {}

        /**
         * Generate a new HTML Object
         *
         * @method getTotalAmountOfSamples
         * @return {int}
         */
        this.getTotalAmountOfSamples = function () {
            _this.config = window.Creaton.Cart.Configuration
            _this.config.totalAmountOfSamples = 0
            $.each(_this.config.cartItems, function (i, item) {
                _this.config.totalAmountOfSamples = _this.config.totalAmountOfSamples + item['amount']
            })
            return _this.config.totalAmountOfSamples
        }

        this.getCartItems = function () {
            _this.config = window.Creaton.Cart.Configuration
            return _this.config.cartItems;
        }
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }
    window.Creaton.CartDataService = CartDataService
})()
